/**
 * FeedbackService - Monitor class for feedback/survey provider integration
 *
 * Works with a pluggable handler (FeedbackServiceHandler) so the underlying
 * provider (Formbricks, etc.) can be swapped by changing only FormbricksHandler
 * and the setHandler call in useFeedback.
 *
 * Usage:
 *   const service = new FeedbackService()
 *   service.setHandler(new FormbricksHandler(config))
 *   service.identify(userId)
 */

export interface FeedbackServiceHandler {
  identify(userId: string, attributes?: Record<string, string>): void;
  reset(): void;
  registerRouteChange(): void;
  setLanguage(language: string): void;
}

export default class FeedbackService {
  handler: FeedbackServiceHandler | null = null;
  enabled: boolean = true;

  setHandler(handler: FeedbackServiceHandler) {
    this.handler = handler;
  }

  enable() {
    this.enabled = true;
  }

  disable() {
    this.enabled = false;
  }

  isEnabled() {
    return this.enabled;
  }

  identify(userId: string, attributes?: Record<string, string>) {
    if (this.isEnabled() && this.handler) {
      this.handler.identify(userId, attributes);
    }
  }

  reset() {
    if (this.isEnabled() && this.handler) {
      this.handler.reset();
    }
  }

  registerRouteChange() {
    if (this.isEnabled() && this.handler) {
      this.handler.registerRouteChange();
    }
  }

  setLanguage(language: string) {
    if (this.isEnabled() && this.handler) {
      this.handler.setLanguage(language);
    }
  }
}
